import { createSlice } from "@reduxjs/toolkit";
import { GetUsers, GetUnits, UpdateUser, GetUserInfo, UpdatePassword } from "services/user/user.service";
import { toast } from 'react-toastify';

export const usersSlice = createSlice({
  name: "users",
  initialState: {
    usersList: [],
    usersLoading: false,
    usersError: null,
  },
  extraReducers: 
  (builder) => {
    builder.addCase(GetUsers.pending, (state) => {
      state.usersLoading = true
    });

    builder.addCase(GetUsers.fulfilled, (state, action) => {
      state.usersList = action.payload
      state.usersLoading = false
      state.usersError = null
    });

    builder.addCase(GetUsers.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't get Users 😣")

      state.usersLoading = false
      state.usersError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});


export const unitsSlice = createSlice({
  name: "unitsSlice",
  initialState: {
    unitList: {},
    unitListLoading: false,
    unitListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetUnits.pending, (state) => {
      state.unitListLoading = true
    });

    builder.addCase(GetUnits.fulfilled, (state, action) => {


      state.unitList = action.payload
      state.unitListLoading = false
      state.unitListError = null
    });

    builder.addCase(GetUnits.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't get units 😣")

      state.unitListLoading = false
      state.unitListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const userUpdateslice = createSlice({
  name: "userUpdate",
  initialState: {
    userUpdate: [],
    userUpdateLoading: false,
    userUpdateError: null,
  },
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateUser.pending, (state) => {
      state.userUpdateLoading = true
    });

    builder.addCase(UpdateUser.fulfilled, (state, action) => {
      state.userUpdate = action.payload
      state.userUpdateLoading = false
      state.userUpdateError = null
    });

    builder.addCase(UpdateUser.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update Users 😣")

      state.userUpdateLoading = false
      state.userUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});


export const userInfoSlice = createSlice({
  name: "userInfo",
  initialState: {
    userInfo: null,
    userInfoLoading: false,
    userInfoError: null,
  },
  reducers: {
    nullifyUserInfo: (state) => { // nulling the last scanning data from state
      state.userInfo = null; // Assign null to the state field
    },
  },
  extraReducers: 
  (builder) => {
    builder.addCase(GetUserInfo.pending, (state) => {
      state.userInfoLoading = true
    });

    builder.addCase(GetUserInfo.fulfilled, (state, action) => {
      state.userInfo = action.payload
      state.userInfoLoading = false
      state.userInfoError = null
    });

    builder.addCase(GetUserInfo.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't get user data from EBS😣")

      state.userInfoLoading = false
      state.userInfoError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const updatePasswordslice = createSlice({
  name: "updatePassword",
  initialState: {
    updatePassword: [],
    updatePasswordLoading: false,
    updatePasswordError: null,
  },
  extraReducers: 
  (builder) => {
    builder.addCase(UpdatePassword.pending, (state) => {
      state.updatePasswordLoading = true
    });

    builder.addCase(UpdatePassword.fulfilled, (state, action) => {
      state.updatePassword = action.payload?.message
      state.updatePasswordLoading = false
      state.updatePasswordError = null
    });

    builder.addCase(UpdatePassword.rejected, (state, action) => {
      // console.log("error: ", action?.payload)
      // toast.error('Error 🤯 😣', action?.error?.message)
      state.updatePasswordLoading = false
      state.updatePasswordError = action?.error

    });
  },
});

export const { nullifyUserInfo } = userInfoSlice.actions